import React from 'react'
import {Router} from '@reach/router'
import {AddResourceParameters} from './add-resource-parameters'
import {CallServiceMock} from './call-service-mock'
import {CreateMockFromContract} from './create-mock-from-contract'
import {CreateWildCardResource} from './create-wild-card-resource'
import {DebugMock} from './debug-mock'
import {InspectRequest} from './inspect-request'
import {CleanUpOrphanedResponses} from './clean-up-orphaned-responses'
import {PrioritizeMockResources} from './prioritize-mock-resources'
import {PrioritizeMockResponses} from './priotize-mock-responses'
import {ProxyFromRealServices} from './proxy-from-real-services'
import {ResolveMockContractConflicts} from './resolve-mock-contract-conflicts'
import {ScriptMockResponseActivation} from './script-mock-response-activation'
import {SecureMock} from './secure-mock'
import {SetupYourTeam} from './set-up-your-team'
import {ShareMockDocsLink} from './share-mock-docs-link'
import {SimulateDelay} from './simulate-delay'
import {TemplateResponse} from './template-response'

const HowToSection = () => {
  return (
    <Router>
      <AddResourceParameters path='add-resource-parameters'/>
      <CallServiceMock path='call-service-mock'/>
      <CreateMockFromContract path='create-mock-from-contract'/>
      <CreateWildCardResource path='create-wildcard-resource'/>
      <CleanUpOrphanedResponses path='clean-up-orphaned-responses'/>
      <DebugMock path='debug-mock'/>
      <InspectRequest path='inspect-request'/>
      <PrioritizeMockResources path='prioritize-mock-resources'/>
      <PrioritizeMockResponses path='prioritize-mock-responses'/>
      <ProxyFromRealServices path='proxy-from-real-services'/>
      <ResolveMockContractConflicts path='resolve-mock-contract-conflicts'/>
      <ScriptMockResponseActivation path='script-mock-response-activation'/>
      <SecureMock path='secure-mock'/>
      <SetupYourTeam path='setup-your-team'/>
      <ShareMockDocsLink path='share-mock-docs-link'/>
      <SimulateDelay path='simulate-delay'/>
      <TemplateResponse path='template-response'/>
    </Router>
  )
}

export {HowToSection}

export default HowToSection